import { Button } from '@hawkins/components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import NetflixGradientBackground from 'src/components/elements/NetflixGradientBackground';

function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <NetflixGradientBackground>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '20px'
      }}>
        <div style={{
          position: 'absolute',
          top: '80px',
          width: '100%',
          display: 'flex',
          justifyContent: 'center'
        }}>
          <img 
            src="/nflx-logo-classic@150w.png" 
            alt="Netflix" 
            style={{ height: '80px' }}
          />
        </div>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          maxWidth: '450px'
        }}>
          <div style={{
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            padding: '48px 68px 36px 68px',
            borderRadius: '4px',
            width: '100%',
            minWidth: '350px',
            textAlign: 'center'
          }}>
            <div style={{
              color: 'white',
              fontSize: '72px',
              fontWeight: '700',
              marginBottom: '16px',
              lineHeight: '1'
            }}>
              404
            </div>

            <div style={{
              color: 'white',
              fontSize: '32px',
              fontWeight: '700',
              marginBottom: '16px'
            }}>
              {t('common.notFound.title')}
            </div>

            <div style={{
              color: 'rgba(255, 255, 255, 0.8)',
              fontSize: '16px',
              marginBottom: '32px',
              lineHeight: '1.4'
            }}>
              {t('common.notFound.message')}
            </div>

            <Button
              onClick={handleGoHome}
              variant="primary"
              style={{
                width: '100%',
                backgroundColor: '#e50914',
                border: 'none',
                borderRadius: '4px',
                color: 'white',
                fontSize: '16px',
                fontWeight: '700',
                padding: '12px 16px',
                cursor: 'pointer',
                height: '48px',
                minHeight: '48px',
                boxSizing: 'border-box'
              }}
            >
              {t('common.actions.goHome')}
            </Button>
          </div>
        </div>
      </div>
    </NetflixGradientBackground>
  );
}

export default NotFoundPage;